module.exports = __webpack_public_path__ + "static/media/WarungSepakat_preview.3ec4a746.jpg";